<template>
    <div class="login-main-container">
        <div class="login-center-container">
            <div class="text-center mt-15">
                <img src="../assets/images/balady.png" alt="" class="mb-0">
            </div>
            <v-card :loading="loading"
                    elevation="3"
                    class="mt-5 pb-7 ps-6 pe-6 mb-3">
                <v-container>
                    <div class="text-center pt-4 pb-4">
                        <h3 class="tile">
                            {{ $t("RegisterUser") }}
                        </h3>

                    </div>
                    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="save" :disabled="loading">
                        <v-container>
                            <v-row>
                                <!--<v-col cols="12" md="6" class="mb-4">
            <v-switch v-model="user.approved" :label="$t('Approved')" color="teal" disabled />
        </v-col>-->
                                <!--<v-col cols="12" md="6" class="mb-4">
            <v-select v-model="user.defaultLanguageId" :items="languages" item-text="name" item-value="id" :label="$t('SelectLanguage')" readonly />
        </v-col>-->
                                <v-col cols="12" md="6"><v-text-field v-model="user.fullnameAr" dense :label="$t('FullNameAr')" :rules="nameRules" required /></v-col>
                                <v-col cols="12" md="6"><v-text-field v-model="user.fullnameEn" dense :label="$t('FullNameEn')" :rules="nameRules" required /></v-col>
                                <v-col cols="12" md="6"><v-text-field v-model="user.username" dense :label="$t('Username')" :rules="nameRules" required /></v-col>
                                <v-col cols="12" md="6"><v-text-field v-model="user.email" dense :label="$t('Email')" :rules="emailRules" required /></v-col>
                                <v-col cols="12" md="6"><v-text-field v-model="user.mobile" dense :label="$t('Mobile')" required /></v-col>
                                <v-col cols="12" md="6"><v-text-field v-model="user.nationalId" dense :label="$t('NationalId')" required /></v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field :type="show ? 'text' : 'password'"
                                                  v-model="password1"
                                                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                  @click:append="show = !show"
                                                  :rules="[rules.required, rules.min8, rules.nospaces, rules.complex, rules.nomatch1]"
                                                  autocomplete="off"
                                                  :label="$t('Password')"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field :type="show ? 'text' : 'password'"
                                                  v-model="password2"
                                                  :rules="[rules.required, rules.nomatch2, rules.min8, rules.nospaces, rules.complex]"
                                                  autocomplete="off"
                                                  :label="$t('ConfirmPassword')"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <div class="captcha-container">
                                        <img :src="captchaImage" alt="CAPTCHA" style="margin-bottom: 10px;" />
                                        <v-text-field dense outlined v-model="userInput" class="captcha-input" :placeholder="$t('Captcha')" append-outer-icon="mdi-reload" @click:append-outer="generateCaptcha" />
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12">
                                    <v-btn color="error" class="white--text ms-3 float-end" tile :disabled="posting" small @click="resetUserObj()">
                                        {{ $t("Cancel") }}
                                    </v-btn>
                                    <v-btn color="primary" class="white--text ms-3 float-end" tile :disabled="posting" small @click="save()">
                                        {{ $t("Add") }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <div v-if="showMessage"
                                     class="mt-2 ms-2 me-2 error--text">
                                    <h3>{{ message }}</h3>

                                </div>
                            </v-row>
                            <div v-if="errorCaptcha" class="mt-2 ms-2 me-2 error--text">{{ $t('CAPTCHA verification failed') }}</div>
                        </v-container>

                    </v-form>

                </v-container>
            </v-card>
        </div>
    </div>
</template>
<script>
    import UsersService from '@/services/UsersService.js'
    import AuthService from '@/services/AuthService.js'
    

    export default {
        data() {
            return {
                password1: null,
                password2: null,
                show: false,
                valid: true,
                posting: false,
                loading: false,
                showMessage: false,
                captchaTextArray: [],
                userInput: '',
                errorCaptcha: false,
                message: this.$t('message'),
                languages: [{ name: 'Arabic', id: 1 }, { name: 'English', id: 2 }],
                user: {
                    id: null,
                    fullnameAr: '',
                    fullnameEn: '',
                    username: '',
                    email: '',
                    mobile: null,
                    nationalId: null,
                    defaultLanguageId: 1,
                    approved: false
                },
                emailRules: [
                    v => !!v || this.$t('RequiredField'),
                    v => /.+@.+\..+/.test(v) || this.$t('ValidEmail')
                ],
                nameRules: [
                    v => !!v || this.$t('RequiredField')
                ],
                rules: {
                    required: (v) => !!v || this.$t('Required'),
                    min8: (v) => v && v.length >= 8 || this.$t('Atleast8Characters'),
                    nospaces: (v) => v && v.match(/^\S*$/g) != null || this.$t('spaces-not-allowed'),
                    complex: (v) => v && v.match(/(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~!@#$%^*\-\_=+[{\]};:,.?])/g) != null || this.$t('ComplexPassword'),
                    nomatch1: (v) => !this.password2 || v == this.password2 || this.$t('PasswordsDontMatch'),
                    nomatch2: (v) => !this.password1 || v == this.password1 || this.$t('PasswordsDontMatch'),
                },
                guidId: null,
                captchaImage: null
            }
        },

        computed: {

        },
        created() {

        },
        filters: {
            reverse: function (array) {
                return array.slice().reverse()
            }
        },
        mounted() {
            this.generateCaptcha()
        },
        methods: {
            async verifyCaptcha() {
                if (!this.userInput || !this.guidId) {
                    this.errorCaptcha = true
                    return false
                }

                try {
                    const result = await AuthService.VerificateCaptch(this.userInput.toUpperCase(), this.guidId)
                    this.errorCaptcha = !result
                    return result
                } catch (error) {
                    console.error('Error verifying captcha:', error)
                    this.errorCaptcha = true
                    return false
                }
            },
            generateCaptcha() {
                // Use server-side captcha generation instead of client-side
                AuthService.captcha()
                    .then(result => {                        
                        this.guidId = result.guidId
                        this.captchaImage = 'data:image/png;base64,' + result.captchaImage
                    })
                    .catch(error => {
                        console.error('Error loading CAPTCHA image:', error)
                    })
            },
            async save() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    this.posting = true
                    this.user.password = this.password2
                    
                    // First verify captcha using server-side validation
                    const captchaValid = await this.verifyCaptcha()
                    if (!captchaValid) {
                        this.posting = false
                        this.loading = false
                        return
                    }

                    UsersService.registerUser(this.user).then((res) => {                            
                        if (res.data === false) {
                            this.showMessage = true
                            this.message = this.$t('EmailOrUsernameAlreadyExistsInTheSystem')
                        } else {
                            this.showMessage = true
                            this.$refs.form.resetValidation()
                            this.resetUserObj()
                            this.$root.$notification(this.$t('UserRegisteredSuccefully'), 'success')
                            this.message = this.$t('TheAdministratorReceivedYourRequest')
                        }
                    }).catch(() => {
                        this.message = this.$t('ErrorOccurred')
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.posting = false
                        this.loading = false
                    })
                }
            },

            resetUserObj() {
                if (this.user) {
                    this.user.id = null
                    this.user.fullnameAr = ''
                    this.user.fullnameEn = ''
                    this.user.username = ''
                    this.user.email = ''
                    this.user.mobile = ''
                    this.user.nationalId = null
                    this.user.defaultLanguageId = 1
                    this.user.approved = false
                    this.password1 = ''
                    this.password2 = ''
                    this.show=  false

                }
            }
        }
    }
</script>
<style scoped>

    .login-main-container { height: 100%; overflow: hidden; width: 100%; background: url(../assets/images/LoginBG.jpg); background-repeat: no-repeat; background-size: cover; background-position: center }


    .login-center-container { width: auto; margin: 0 auto; max-width: 700px }
    .captcha-container { text-align: center; }

    .captcha-text { font-size: 24px; margin-bottom: 10px; color: #333; background: url(../assets/images/captcha.jpg); }

        .captcha-text span { display: inline-block; font-family: Arial, sans-serif; letter-spacing: 8px; text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5); }

    .captcha-overlay { position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; }

        .captcha-overlay::before,
        .captcha-overlay::after { content: ''; position: absolute; width: 100%; height: 1px; background-color: #ccc; }

        .captcha-overlay::before { top: 30%; }

        .captcha-overlay::after { bottom: 30%; }


    .captcha-button { background-color: #4CAF50; color: white; padding: 10px 20px; border: none; border-radius: 4px; cursor: pointer; }

        .captcha-button:hover { background-color: #45a049; }

    .captcha-regenerate { cursor: pointer; margin-left: 10px; font-size: 24px; color: #2196F3; }

        .captcha-regenerate:hover { color: #1976D2; }

    .verification-message { margin-top: 10px; font-weight: bold; }
</style>